module.exports = __webpack_public_path__ + "static/media/icone newbot.c2afc5ab.svg";